<nav class="py-8 bg-white">
  <div class="nav__container container mx-auto flex justify-between">
    <a
      [routerLink]="['/', i18nService.language]"
      class="nav__logo flex items-center gap-4"
    >
      <div class="logo_icon" inlineSVG="nav/logo.svg"></div>
      <p translate>Posty 5</p>
    </a>

    <ul class="nav__links large__screen flex items-center gap-4">
      <li
        routerLinkActive="active"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
      >
        <a [routerLink]="['/', i18nService.language]" translate="Home"> </a>
      </li>
      <li
        routerLinkActive="active"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
      >
        <a
          [routerLink]="['/', i18nService.language, 'url-shortener']"
          translate="URL Shortener"
        >
        </a>
      </li>
      <li
        routerLinkActive="active"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
      >
        <a
          [routerLink]="['/', i18nService.language, 'qr-code-generator']"
          translate="QR Code Generator"
        >
        </a>
      </li>
      <li
        routerLinkActive="active"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
      >
        <a
          [routerLink]="['/', i18nService.language, 'seo-tags-extractor']"
          translate="SEO Extractor"
        >
        </a>
      </li>
      <li
        routerLinkActive="active"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
        [ngClass]="{ active: isOpen }"
        (mouseover)="isOpen = true"
        (mouseleave)="isOpen = false"
      >
        <div class="mega__tool flex items-center gap-2">
          <div class="icon" inlineSVG="nav/chevron-down.svg"></div>
          <span translate="Tools"></span>
        </div>
        <div
          class="mega__dropdown grid sm:grid-cols-2 grid-cols-1 gap-x-2 gap-y-4"
          [ngClass]="{ dropdown__open: isOpen }"
          (mouseover)="isOpen = true"
          (mouseleave)="isOpen = false"
        >
          <a
            [routerLink]="['/', i18nService.language, 'html-hosting']"
            class="dropdown__tool"
            routerLinkActive="active"
          >
            <div class="tool__logo">
              <div inlineSVG="our-tools/html-hosting.svg"></div>
            </div>

            <div class="tool__desc">
              <h3 class="tool__name" translate>HTML hosting</h3>
              <p class="tool__properties" translate>Free , Easy , Editable</p>
            </div>
          </a>
          <a
            [routerLink]="['/', i18nService.language, 'crop-photo']"
            class="dropdown__tool"
            routerLinkActive="active"
          >
            <div class="tool__logo">
              <div inlineSVG="our-tools/gallery.svg"></div>
            </div>

            <div class="tool__desc">
              <h3 class="tool__name" translate>Crop Photos</h3>
              <p class="tool__properties" translate>Free , Easy , Editable</p>
            </div>
          </a>
          <a
            [routerLink]="[
              '/',
              i18nService.language,
              'whatsapp-message-link-generator',
            ]"
            class="dropdown__tool"
            routerLinkActive="active"
          >
            <div class="tool__logo">
              <div inlineSVG="our-tools/whatsapp.svg"></div>
            </div>

            <div class="tool__desc">
              <h3 class="tool__name" translate>
                WhatsApp Message Link Generator
              </h3>
              <p class="tool__properties" translate>Free , Easy , Smart</p>
            </div>
          </a>

          @defer {
            @if (authGuardService.isLoggedIn()) {
              <a
                [routerLink]="[
                  '/',
                  i18nService.language,
                  'qr-code-template-creator',
                ]"
                class="dropdown__tool"
                routerLinkActive="active"
              >
                <div class="tool__logo">
                  <div inlineSVG="our-tools/scan-barcode.svg"></div>
                </div>

                <div class="tool__desc">
                  <h3 class="tool__name" translate>Qr Code Template Creator</h3>
                  <p class="tool__properties" translate>Free , Easy , Smart</p>
                </div>
              </a>
            }
          }
        </div>
      </li>
    </ul>

    @defer {
      @if (authGuardService.isLoggedIn() === false) {
        <div class="nav__auth large__screen flex items-center gap-4">
          <a
            [routerLink]="['/', i18nService.language, 'sign-up']"
            class="primary__btn-outline"
            translate="Sign Up"
          ></a>
          <a
            [routerLink]="['/', i18nService.language, 'login']"
            class="primary__btn"
            translate="Login"
          ></a>
        </div>
      }
    } @placeholder {
      <div class="nav__auth large__screen flex items-center gap-4">
        <a
          [routerLink]="['/', i18nService.language, 'sign-up']"
          translate="Sign Up"
        ></a>
        <a
          [routerLink]="['/', i18nService.language, 'login']"
          translate="Login"
        ></a>
      </div>
    }

    <!-- Toggle and user in small screens-->
    <div
      class="nav__controllers flex items-center gap-4"
      [ngClass]="{ small__screen: !authGuardService.isLoggedIn() }"
    >
      @if (authGuardService.isLoggedIn()) {
        <div class="user large__screen flex items-center gap-4">
          <p class="user__name" [title]="authGuardService.currentUser.fullName">
            {{ authGuardService.currentUser.fullName | ellipsis: 14 }}
          </p>
          <div class="user__actions flex items-center gap-2">
            <img [src]="picturePath()" alt="user-img" />
            <div class="icon" inlineSVG="nav/chevron-down.svg"></div>
            <div class="user__dropdown">
              <a href="/dashboard" translate>Dashboard</a>
              <button (click)="authGuardService.logout()" translate>
                Logout
              </button>
            </div>
          </div>
        </div>
      }

      <div class="toggle" (click)="toggleMenu()">
        <div inlineSVG="nav/menu.svg"></div>
      </div>
    </div>

    <!-- Small Screens Menu -->
    <div class="mobile__menu" [ngClass]="{ active: menuOpen }">
      <div class="mobile__content flex flex-col gap-6">
        <div class="menu__header flex justify-between items-center">
          <div class="nav__logo flex items-center gap-4 !text-[1rem]">
            <div class="logo" inlineSVG="nav/logo.svg"></div>
            <p translate>Posty 5</p>
          </div>

          <div
            class="close__icon"
            inlineSVG="nav/close.svg"
            (click)="toggleMenu()"
          ></div>
        </div>

        @if (authGuardService.isLoggedIn()) {
          <div class="user__account flex items-center gap-4">
            <img [src]="picturePath()" alt="user-img" />

            <h2
              class="username"
              [title]="authGuardService.currentUser.fullName"
            >
              {{ authGuardService.currentUser.fullName | ellipsis: 14 }}
            </h2>
          </div>
        }
        <ul
          class="nav__links flex flex-col items-start gap-4"
          (click)="menuOpen = false"
        >
          <li
            routerLinkActive="active"
            [routerLinkActiveOptions]="routerLinkActiveOptions"
          >
            <a [routerLink]="['/', i18nService.language]">
              <span translate="Home"></span>
              <div inlineSVG="nav/chevron-right.svg"></div>
            </a>
          </li>
          <li
            routerLinkActive="active"
            [routerLinkActiveOptions]="routerLinkActiveOptions"
          >
            <a [routerLink]="['/', i18nService.language, 'url-shortener']">
              <span translate="URL Shortener"></span>
              <div inlineSVG="nav/chevron-right.svg"></div>
            </a>
          </li>
          <li
            routerLinkActive="active"
            [routerLinkActiveOptions]="routerLinkActiveOptions"
          >
            <a [routerLink]="['/', i18nService.language, 'qr-code-generator']">
              <span translate="QR Code Generator"></span>
              <div inlineSVG="nav/chevron-right.svg"></div>
            </a>
          </li>

          @defer {
            @if (authGuardService.isLoggedIn()) {
              <li
                routerLinkActive="active"
                [routerLinkActiveOptions]="routerLinkActiveOptions"
              >
                <a
                  [routerLink]="[
                    '/',
                    i18nService.language,
                    'qr-code-template-creator',
                  ]"
                >
                  <span translate="QR Code Template Creator"></span>
                  <div inlineSVG="nav/chevron-right.svg"></div>
                </a>
              </li>
            }
          }
          <li
            routerLinkActive="active"
            [routerLinkActiveOptions]="routerLinkActiveOptions"
          >
            <a [routerLink]="['/', i18nService.language, 'seo-tags-extractor']">
              <span translate="SEO Extractor"></span>
              <div inlineSVG="nav/chevron-right.svg"></div>
            </a>
          </li>

          <li
            routerLinkActive="active"
            [routerLinkActiveOptions]="routerLinkActiveOptions"
          >
            <a [routerLink]="['/', i18nService.language, 'html-hosting']">
              <span translate="HTML Hosting"></span>
              <div inlineSVG="nav/chevron-right.svg"></div>
            </a>
          </li>

          <li
            routerLinkActive="active"
            [routerLinkActiveOptions]="routerLinkActiveOptions"
          >
            <a [routerLink]="['/', i18nService.language, 'crop-photo']">
              <span translate="Crop Photo"></span>
              <div inlineSVG="nav/chevron-right.svg"></div>
            </a>
          </li>
          <li
            routerLinkActive="active"
            [routerLinkActiveOptions]="routerLinkActiveOptions"
          >
            <a
              [routerLink]="[
                '/',
                i18nService.language,
                'whatsapp-message-link-generator',
              ]"
            >
              <span translate="WhatsApp Message Link Generator"></span>
              <div inlineSVG="nav/chevron-right.svg"></div>
            </a>
          </li>

          @defer {
            @if (authGuardService.isLoggedIn()) {
              <li>
                <a href="/dashboard" translate="Dashboard"> </a>
              </li>
            }
          }
        </ul>
        @defer {
          @if (authGuardService.isLoggedIn()) {
            <div
              class="nav__logout flex items-center justify-between mt-auto text-center"
              (click)="authGuardService.logout(); menuOpen = false"
            >
              <p translate="log out"></p>
              <div inlineSVG="nav/logout.svg"></div>
            </div>
          } @else {
            <div
              class="nav__auth flex flex-col md:flex-row items-center gap-4 text-center"
              (click)="toggleMenu()"
            >
              <a
                [routerLink]="['/', i18nService.language, 'sign-up']"
                class="primary__btn-outline w-full"
                translate="Sign Up"
              ></a>
              <a
                [routerLink]="['/', i18nService.language, 'login']"
                class="primary__btn w-full"
                >Login</a
              >
            </div>
          }
        } @placeholder {
          <a
            [routerLink]="['/', i18nService.language, 'sign-up']"
            translate="Sign Up"
          ></a>
          <a
            [routerLink]="['/', i18nService.language, 'login']"
            translate="Login"
          ></a>
        }
      </div>
      <div class="overlay" (click)="toggleMenu()"></div>
    </div>
  </div>
</nav>
